import Vue from 'vue'
import Vuex from 'vuex'
import VuexReset from '@ianwalter/vuex-reset'
import createPersistedState from 'vuex-persistedstate'

// Global store
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

// Module store
import auth from '@/modules/auth/store'
import cart from '@/modules/cart/store'
import checkout from '@/modules/checkout/store'
import home from '@/modules/home/store'
import order from '@/modules/order/store'
import product from '@/modules/product/store'
import profile from '@/modules/profile/store'
import supplier from '@/modules/supplier/store'
import sourcing from '@/modules/sourcing/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    auth,
    cart,
    checkout,
    home,
    order,
    product,
    profile,
    supplier,
    sourcing
  },
  plugins: [
    VuexReset({ trigger: mutations.reset_state }),
    createPersistedState({ storage: window.localStorage || window.sessionStorage })
  ]
})

export default store
